import script from "./saleSampleDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./saleSampleDetail.vue?vue&type=script&setup=true&lang=js"

import "./saleSampleDetail.vue?vue&type=style&index=0&id=b60df08a&lang=less"

const __exports__ = script;

export default __exports__